export const formatOrderPrice = (price: string): string => (price === '0.00' ? 'FREE' : `£${price}`)
